import React, { useRef, useCallback, useEffect } from 'react';
import { shape, arrayOf, string, func, number } from 'prop-types';
import cx from 'classnames';

import styles from './RadioGroup.scss';

function RadioGroup({ options, value, onChange, className }) {
  const indicatorRef = useRef(null);

  const onMoveIndicator = useCallback(target => {
    const { offsetWidth, offsetLeft } = target;

    const indicatorElm = indicatorRef.current;
    indicatorElm.style.width = `${offsetWidth}px`;
    indicatorElm.style.transform = `translateX(${offsetLeft}px)`;
  }, []);

  const onRadioChange = useCallback(
    event => {
      const lastValue = value;
      const targetValue = event.target.value;

      if (onChange && targetValue !== lastValue) {
        onChange(+event.target.value);
      }
    },
    [onChange, value]
  );

  useEffect(() => {
    const checkedElement = document.querySelector(`.${styles.checked}`);
    if (!checkedElement) return;

    onMoveIndicator(checkedElement);
  }, [onMoveIndicator, value]);

  return (
    <div className={cx(styles.root, className)}>
      {options.map(option => (
        <label
          key={option.value}
          htmlFor={option.value}
          className={cx(styles.label, {
            [styles.checked]: option.value === value,
          })}
        >
          <input
            onChange={onRadioChange}
            type="radio"
            value={option.value}
            id={option.value}
            checked={option.value === value}
          />
          <span>{option.label}</span>
        </label>
      ))}
      <div ref={indicatorRef} className={styles.indicator} />
    </div>
  );
}

RadioGroup.propTypes = {
  value: number.isRequired,
  onChange: func.isRequired,
  className: string,
  options: arrayOf(
    shape({
      value: number.isRequired,
      label: string.isRequired,
    })
  ),
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./app/containers/Premium/components/SubscriptionSection/components/RadioGroup/RadioGroup.jsx